import { Link } from 'react-router';
import { Avatar } from '../avatar';
import { Text } from '../typography';

type P = {
  fallbackPhoto?: string;
  link: string;
  name: string;
  photoUrl?: string;
};

const NavigationPill = ({ fallbackPhoto, link, name, photoUrl }: P) => (
  <Link className="navigation-pill" to={link}>
    {/* TODO avatar size hardcoded */}
    {photoUrl ? (
      <div className="navigation-pill__avatar">
        <Avatar fallbackPhoto={fallbackPhoto} photo={photoUrl} size={16} />
      </div>
    ) : null}

    <Text ellipsis>{name}</Text>
  </Link>
);

export default NavigationPill;
